import { ILayoutFilter } from '@base/@types/components/Layout/Filters'

export const reportFilter: ILayoutFilter[] = [
  {
    id: 'empresaIds',
    label: 'Empresa',
    type: 'checkbox'
  },
  {
    id: 'empresaSelectIds',
    label: '',
    filterId: 'companies',
    type: 'select',
    isMulti: true
  },
  {
    id: 'centroCdLojaIds',
    label: 'Centro (CD/Loja)',
    type: 'checkbox',
    agroupDefault: true
  },
  {
    id: 'centroCdLojaSelectIds',
    label: '',
    filterId: 'centers',
    type: 'select',
    isMulti: true
  },
  {
    id: 'categoriasIds',
    label: 'Categoria Compacta',
    type: 'checkbox'
  },
  {
    id: 'categoriasSelectIds',
    label: '',
    filterId: 'compactCategories',
    type: 'select',
    isMulti: true
  },
  {
    id: 'categoriaIds',
    label: 'Categoria',
    type: 'checkbox'
  },
  {
    id: 'categoriaSelectIds',
    label: '',
    filterId: 'categories',
    type: 'select',
    isMulti: true
  },
  // {
  //   id: 'gerenteCategoriaIds',
  //   label: 'Gerente de Categoria',
  //   type: 'checkbox'
  // },
  // {
  //   id: 'gerenteCategoriaSelectIds',
  //   label: '',
  //   filterId: 'categoryManagers',
  //   type: 'select',
  //   isMulti: true
  // },
  {
    id: 'gerenteProdutoIds',
    label: 'Gerente de Produto',
    type: 'checkbox'
  },
  {
    id: 'gerenteProdutoSelectIds',
    label: '',
    filterId: 'productManagers',
    type: 'select',
    isMulti: true
  },
  {
    id: 'anosIds',
    label: 'Ano',
    type: 'checkbox'
  },
  {
    id: 'anosSelectIds',
    label: '',
    filterId: 'yearBudget',
    type: 'select',
    isMulti: true
  },
  {
    id: 'mesesIds',
    label: 'Mês',
    type: 'checkbox'
  },
  {
    id: 'mesesSelectIds',
    label: '',
    filterId: 'monthBudget',
    type: 'select',
    isMulti: true
  },
  {
    id: 'historicoIds',
    label: 'Historico',
    type: 'checkbox'
  },
  {
    id: 'historicoSelectIds',
    label: '',
    filterId: 'historicBudget',
    type: 'select',
    isMulti: true
  },
  {
    id: 'operacaoIds',
    label: 'Operação',
    type: 'checkbox'
  },
  {
    id: 'operacaoSelectIds',
    label: '',
    filterId: 'operationBudget',
    type: 'select',
    isMulti: true
  }
]
